const base = 0;
const above = 1;

export const openButton = above + base;
export const flapOut = above + openButton;
export const backDrop = above + flapOut;
export const slideIn = above + backDrop;
export const feedback = above + slideIn;
